import { Spacer, Text } from '@loomhq/lens';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { updateVideoPlayerCommentMarkers } from 'actions/videoPlayer';
import {
  EMBED_VIDEO_CORRECT_PASS,
  EMBED_VIDEO_PROCESSING_INFORMATION_UPDATED,
} from 'constants/messages';
import { fetchCommentsCreator } from 'creators/comments';

import CommentsContent from './player-content';
import HideDuringDowntime from '../../hide-during-downtime';

import './styles.less';

const Comments = class extends Component {
  render() {
    const {
      comments,
      commentsEnabled,
      hasFetched,
      shouldNotLoad,
      fullScreen,
      onCommentDisplay,
    } = this.props;

    if (shouldNotLoad) {
      return null;
    }

    if (comments && comments.length > 0) {
      onCommentDisplay(true);
    } else {
      onCommentDisplay(false);
    }

    return (
      <HideDuringDowntime>
        <div className="comments-view">
          {commentsEnabled && hasFetched && !fullScreen && comments.length > 0 && (
            <div>
              <Spacer top="xlarge" />
              <Text size="large" fontWeight="medium">
                Comments
              </Text>
              <Spacer top="small" />
              <Spacer top="xsmall" />
              <CommentsContent
                drawnOnSharePage={true}
                scrollContainer={document.documentElement}
              />
            </div>
          )}
        </div>
      </HideDuringDowntime>
    );
  }

  componentDidMount() {
    const { shouldNotLoad } = this.props;

    window.top.addEventListener(
      'message',
      event => {
        switch (event.data.type) {
          case EMBED_VIDEO_CORRECT_PASS:
            this.fetchCommentsAndSendMarkers();
            break;
          case EMBED_VIDEO_PROCESSING_INFORMATION_UPDATED:
            this.fetchCommentsAndSendMarkers();
            break;
          default:
            break;
        }
      },
      false
    );

    if (shouldNotLoad) {
      return;
    }

    this.fetchCommentsAndSendMarkers();
  }

  componentDidUpdate(prevProps) {
    const {
      comments: prevComments,
      hasFetched: prevHasFetched,
      iframeLoaded: prevIframeLoaded,
      password: prevPassword,
      video: prevVideo,
    } = prevProps;

    const { comments, hasFetched, iframeLoaded, password, video } = this.props;

    if (video == null) {
      return;
    }

    // if we just got the video, fetch the first comments
    if (video != null && prevVideo == null && !video.needs_password) {
      return this.fetchCommentsAndSendMarkers();
    }

    // if we just got the password, fetch comments
    if (video.needs_password && prevPassword == null && password != null) {
      return this.fetchCommentsAndSendMarkers();
    }

    // if the iframe has just loaded, send the markers
    if (iframeLoaded && !prevIframeLoaded) {
      return this.sendMarkers();
    }

    // send markers anytime comments length changes except first fetch
    if (
      prevComments.length !== comments.length &&
      prevHasFetched === hasFetched
    ) {
      this.sendMarkers();
    }
  }

  fetchCommentsAndSendMarkers = async () => {
    const { video, password } = this.props;

    if (video == null || (video.needs_password && password == null)) {
      return;
    }

    await this.props.fetchComments();
    this.sendMarkers();
  };

  sendMarkers() {
    const { comments, iframeLoaded } = this.props;

    if (!iframeLoaded) {
      return;
    }

    this.props.updateVideoPlayerCommentMarkers(
      comments.map(comment => {
        return { time: comment.time_stamp };
      })
    );
  }
};

const mapStateToProps = state => {
  const { feature_flags: featureFlags } = state;
  const { password, video } = state.share_video;
  const { comments, has_fetched: hasFetched } = state.comments;
  const { full_screen: fullScreen } = state.video_player;

  const shouldNotLoad =
    video == null ||
    (video.needs_password && !password) ||
    video.viewer_needs_permission;

  const { comments_enabled: commentsEnabled } = video;

  return {
    shouldNotLoad,
    comments,
    hasFetched,
    password,
    video,
    featureFlags,
    commentsEnabled,
    fullScreen,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchComments: () => dispatch(fetchCommentsCreator()),
    updateVideoPlayerCommentMarkers: markers =>
      dispatch(updateVideoPlayerCommentMarkers(markers)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Comments);
